export default __webpack_public_path__ + "static/media/home-banner-illustration.9dc262ad.svg";